<app-navigation
  *ngIf="navigationItems.length > 0"
  [appearance]="navigationAppearance.thin"
  [mode]="isScreenSmall ? navigationMode.over : navigationMode.side"
  [navigationItems]="navigationItems"
  [opened]="!isScreenSmall || sideBarOpened"
></app-navigation>
